import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

const TableSkeleton = ({ rows, columns, colsData }) => {
  return (
    <Grid container spacing={2}>  

    {colsData && colsData.length >0&& <Grid item xs={12} >
          <Grid container spacing={3}>
            {colsData.map((colum,index)=><Grid item xs key={index}>{colum["label"]}</Grid>)}
           
          </Grid>
    </Grid>
    }

      {Array.from({ length: rows }, (_, rowIndex) => (
        <Grid item xs={12} key={rowIndex}>
          <Grid container spacing={3}>
            {Array.from({ length: columns }, (_, colIndex) => (
              <Grid item xs key={colIndex}>
                <Skeleton variant="text" animation="wave" height={30} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default TableSkeleton;
